var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
export var ChevronRight = function (props) { return (React.createElement("svg", __assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.72964 2.9064C4.53438 2.71114 4.53439 2.39456 4.72965 2.1993L5.08321 1.84575C5.27847 1.65048 5.59505 1.65048 5.79031 1.84575L11.2704 7.32582C11.4657 7.52108 11.4657 7.83767 11.2704 8.03293L5.79031 13.513C5.59505 13.7083 5.27847 13.7083 5.08321 13.513L4.72965 13.1594C4.53439 12.9642 4.53438 12.6476 4.72964 12.4523L9.50243 7.67938L4.72964 2.9064Z", fill: "currentColor" }))); };
export default ChevronRight;
//# sourceMappingURL=ChevronRight.js.map